import { Link } from "react-router-dom";
import { Blocks, Facebook, Instagram, Twitter } from "lucide-react";
import { useTranslation } from "react-i18next";

const Footer = () => {
  const { t } = useTranslation();
  return (
    <footer data-web-footer="true" className="bg-foreground text-primary-foreground">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Brand */}
          <div className="space-y-4">
            <div className="flex items-center gap-2">
              <div className="p-2 rounded-xl gradient-hero">
                <Blocks className="h-6 w-6 text-primary-foreground" />
              </div>
              <span className="text-xl font-display font-bold">Brickshare</span>
            </div>
            <p className="text-sm text-primary-foreground/70 leading-relaxed">
              {t('footer.description')}
            </p>
            <div className="flex gap-4">
              <a href="https://www.facebook.com/brickshare" target="_blank" rel="noopener noreferrer" aria-label="Facebook" className="p-2 rounded-full bg-primary-foreground/10 hover:bg-primary-foreground/20 transition-colors">
                <Facebook className="h-4 w-4" />
              </a>
              <a href="https://www.instagram.com/brickshare_es" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="p-2 rounded-full bg-primary-foreground/10 hover:bg-primary-foreground/20 transition-colors">
                <Instagram className="h-4 w-4" />
              </a>
              <a href="https://twitter.com/brickshare_es" target="_blank" rel="noopener noreferrer" aria-label="Twitter" className="p-2 rounded-full bg-primary-foreground/10 hover:bg-primary-foreground/20 transition-colors">
                <Twitter className="h-4 w-4" />
              </a>
            </div>
          </div>

          {/* Comunidad y Explorar */}
          <div className="space-y-4">
            <h4 className="text-sm font-semibold uppercase tracking-wider">{t('footer.aboutTitle')}</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/sobre-nosotros" className="text-sm text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                  Visión, Misión, Valores
                </Link>
              </li>
              <li>
                <Link to="/proteccion-sets" className="text-sm text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                  {t('footer.setProtection')}
                </Link>
              </li>
              <li>
                <Link to="/preguntas-frecuentes" className="text-sm text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                  Preguntas frecuentes (FAQs)
                </Link>
              </li>
              <li>
                <Link to="/contacto" className="text-sm text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                  {t('footer.contact')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Privacidad y Legal */}
          <div className="space-y-4">
            <h4 className="text-sm font-semibold uppercase tracking-wider">Privacidad y Legal</h4>
            <ul className="space-y-3">
              <li>
                <Link to="/privacidad" className="text-sm text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                  Política de Privacidad
                </Link>
              </li>
              <li>
                <Link to="/cookies" className="text-sm text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                  Política de Cookies
                </Link>
              </li>
              <li>
                <Link to="/terminos-servicio" className="text-sm text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                  Términos y Condiciones del Servicio
                </Link>
              </li>
              <li>
                <Link to="/aviso-legal" className="text-sm text-primary-foreground/70 hover:text-primary-foreground transition-colors">
                  Aviso Legal
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* LEGO Disclaimer */}
      <div className="border-t border-primary-foreground/10">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <p className="text-xs text-primary-foreground/40 text-center">
            {t('footer.legoDisclaimer')}
          </p>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="bg-black/20">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-3">
          <div className="flex flex-col md:flex-row justify-between items-center gap-2">
            <p className="text-xs text-primary-foreground/50">
              © 2026 Infinigames Lab SL · CIF B88693437. {t('footer.rights')}
            </p>
            <div className="flex flex-wrap gap-4 sm:gap-6">
              <Link to="/privacidad" className="text-xs text-primary-foreground/50 hover:text-primary-foreground/70 transition-colors">
                {t('footer.privacy')}
              </Link>
              <Link to="/cookies" className="text-xs text-primary-foreground/50 hover:text-primary-foreground/70 transition-colors">
                {t('footer.cookies')}
              </Link>
              <Link to="/terminos-servicio" className="text-xs text-primary-foreground/50 hover:text-primary-foreground/70 transition-colors">
                {t('footer.terms')}
              </Link>
              <Link to="/aviso-legal" className="text-xs text-primary-foreground/50 hover:text-primary-foreground/70 transition-colors">
                {t('footer.legal')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
